<template>
  <div class="w-full">
    <NText variant="caption1" weight="medium">
      {{
        t('option.deleteSettlementConfirmMessage', {
          instrumentName: position.instrumentName,
          settlementType,
        })
      }}
    </NText>

    <div class="flex items-center justify-center w-full mt-6">
      <NButton
        class="ml-3 flex-1"
        color="gray"
        variant="flat"
        @click="remove()"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        color="red"
        class="mr-3 flex-1"
        :loading="loading"
        :disabled="loading"
        @click="emit('delete', position.isin)"
      >
        {{ t('common.cancelRequest') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';
import { PositionItem } from '@libs/api-reference';

type TDeleteSettlementDialogEmits = {
  (e: 'delete', isin: string): void;
};

type TDeleteSettlementDialogProps = {
  position: PositionItem;
  settlementType: string;
  loading: boolean;
};

const emit = defineEmits<TDeleteSettlementDialogEmits>();

defineProps<TDeleteSettlementDialogProps>();

const { remove } = useDialog();

const { t } = useI18n();
</script>
